// import floatLabels from '../globals/forms';
import {setVarsOnResize, setVars} from '../globals/height';
// import preventOverflow from '../globals/prevent-overflow';
import resizeListener from '../globals/resize';
// import scrollListener from '../globals/scroll';
import wrapElements from '../globals/wrap';
import isTouch from '../util/touch';
// import {ariaToggle} from '../globals/aria-toggle';
// import {loading} from '../globals/loading';

resizeListener();
// scrollListener();
isTouch();
setVars();
// ariaToggle(document);

window.addEventListener('load', () => {
  setVarsOnResize();
  //   floatLabels(document);
  //   preventOverflow(document);
  wrapElements(document);
  //   loading();
});

document.addEventListener('shopify:section:load', (e) => {
  const container = e.target;
  //   floatLabels(container);
  //   preventOverflow(container);
  wrapElements(container);
  //   ariaToggle(document);
  setVarsOnResize();
});
